/*************************
 * Author : Matthieu ROBIN
 *************************/
import moment from "moment";
import * as yup from "yup";

const validationSchema: yup.ObjectSchema<{ brand: string }> = yup
  .object()
  .shape({
    brand: yup.string().required("La marque est requise").trim(),
    type: yup.string().trim(),
    number: yup
      .string()
      .transform((value, originalValue) =>
        originalValue === "" ? null : value,
      )
      .nullable()
      .matches(/^([A-Z0-9]+\/?)+$/, "Le numéro doit être de la forme XX/YY")
      .trim(),
    competition: yup.string().trim(),
    year: yup
      .number()
      .transform((value, originalValue) =>
        originalValue === "" ? null : value,
      )
      .typeError("Format incorrect")
      .nullable()
      .min(1886, "L'année doit être supérieure à 1886")
      .max(moment().year(), "L'année doit être inférieur à l'année courante"),
    pilots: yup.array(yup.string().required().trim()),
    position: yup.string<"1st" | "2nd" | "3rd" | "other">().default("other"),
    manufacturer: yup.string().trim(),
    reference: yup.string().trim(),
    details: yup.string(),
    storageLocation: yup.string().trim(),
    purchasePrice: yup
      .number()
      .transform((value, originalValue) =>
        originalValue === "" ? null : value,
      )
      .nullable()
      .typeError("Format incorrect")
      .positive("Le prix doit être positif"),
    owner: yup.string().trim(),
    photos: yup.array(yup.string().required().trim()),
  });

export default validationSchema;
